import { RecordVoiceOver, VoiceOverOff } from "@mui/icons-material";
import { Box, Button, IconButton, Typography } from "@mui/material";

interface WelcomePageProps {
  onConfirm: () => void;
}

export const WelcomePage: React.FC<WelcomePageProps> = (props) => {
  return (
    <>
      <div style={{ margin: 16 }}>
        <Box height={100} />
        <Typography textAlign="center" textTransform="uppercase">
          Welcome to the world of
          <br />
          <img
            alt="Parivaar Twist"
            src="/assets/misc/title.png"
            height={128}
            style={{ display: "block", margin: "auto" }}
          />
        </Typography>
        <Box height={32} />
        <Typography textAlign="center">
          This interactive pitch deck includes <b>voice samples</b> for
          characters, so that you can get a better sense of their personalities.
          Set your <b>media volume</b> is set to <b>high</b> so that you don't
          miss them!
        </Typography>
        <br />
        <br />
        <Box display="flex" justifyContent="center">
          <Typography>
            <IconButton color="warning">
              <RecordVoiceOver />
            </IconButton>
            Click this button to make a character speak!
            <br />
            <br />
            <IconButton color="success">
              <RecordVoiceOver />
            </IconButton>
            The button will turn green when a character is speaking.
            <br />
            <br />
            <IconButton color="error">
              <VoiceOverOff />
            </IconButton>
            If the button is red and striked out, the character can't speak yet.
            Check back soon! :-)
          </Typography>
        </Box>
        <Box height={48} />
        <Box display="flex" justifyContent="center">
          <Button variant="contained" onClick={props.onConfirm}>
            ENTER
          </Button>
        </Box>
      </div>
    </>
  );
};
